<div [style.height.px]="height" [style.width.px]="width">
  @if (type === "Case") {
    <img class="appear_2" src="../../../assets/icons/icon-case.svg" alt="" />
  }

  @if (type === "Group") {
    <div id="conversation-picture-container">
      <img class="appear_2" src="../../../assets/icons/icongroup.svg" alt="" />
      @if (!!conversationPictureUri) {
        <img
          class="image overlay"
          [class.hidden]="!isConversationImageLoaded"
          [src]="conversationPictureUri | clink | secure"
          (load)="handleConversationImageLoaded()"
        />
      }
    </div>
  }

  @if (
    (type === "User" ||
      type === "Chat" ||
      type === "SelfChat" ||
      type === "TeamChat" ||
      type === "External") &&
    participant
  ) {
    <div class="appear_2">
      <app-avatar
        [name]="participant.firstName + ' ' + participant.lastName"
        [userId]="participant.userId"
        [width]="width"
        [height]="height"
        [hasImage]="!!participant.profilePic && type !== 'External'"
        [picUrl]="participant.profilePic"
        [refreshCount]="refreshCount"
        [doNotDisturbToUtc]="showDNDBadge ? participant.doNotDisturbToUtc : ''"
        [dndBadgeSize]="'16'"
        [badgeMargin]="'-1'"
        [badgeBorder]="'1'"
        [dndMessage]="participant.firstName + ' is set to do not disturb'"
        [showBadge]="showBadge"
        [badgeSize]="badgeSize"
        [workspaces]="participant.workplaces"
        [user]="participant"
        [identityVerificationStatus]="participant.identityVerificationStatus"
        [showTooltip]="false"
        [clickable]="clickable"
        [name_identity_verified_as]="
          participant.legalFirstName + ' ' + participant.lastName
        "
        [isExternal]="participant.isExternal ?? false"
      ></app-avatar>
    </div>
  }
  <!-- Never leave the reserved avatar space blank for external chats, where the
       external party may not be resolvable as a participant yet. -->
  @if (type === "External" && !participant) {
    <div class="appear_2">
      <app-avatar
        [width]="width"
        [height]="height"
        [hasImage]="false"
        [showBadge]="showBadge"
        [badgeSize]="badgeSize"
        [showTooltip]="false"
        [clickable]="clickable"
        [isExternal]="true"
      ></app-avatar>
    </div>
  }
</div>
